import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actions } from "../../../../../Redux";
import Headerbar from "../../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../../Components/InnerLayout/UserInterface";
import MultiRangeSlider from "../../../../Components/MultiRangeSlider";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useHistory } from "react-router-dom";

const Discounts = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const discountsData = useSelector(
    (state) => state?.financeReducer?.discountsData
  );

  console.log(discountsData, "discountsData");

  const firstDateOfMonth =
    new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + 1;

  const initialData = {
    from_date: moment(firstDateOfMonth).format("yyyy-MM-DD"),
    to_date: moment(new Date()).format("yyyy-MM-DD"),
    start_time: "08:05 AM",
    end_time: "11:59 PM",
    page: 1,
    pagesize: 2,
  };
  const [startDate, setStartDate] = useState(moment(firstDateOfMonth).toDate());
  const [endDate, setEndDate] = useState(new Date());
  const [data, setData] = useState(initialData);

  function handleClick(page) {
    const postData = { ...data };
    if (postData.type === "") delete postData.type;
    if (postData.payment_method === "") delete postData.payment_method;
    if (postData.status === "") delete postData.status;

    dispatch(actions.getDiscountsData({ ...postData, page }));
  }

  useEffect(() => {
    dispatch(actions?.getDiscountsData(initialData));
    return () => {
      dispatch(actions?.saveDiscountsData(null));
      dispatch(actions?.saveRefundsBillData(null));
      dispatch(actions?.saveInnerMenuItemsData(null));
      dispatch(actions?.saveInnerComponentData(null));
    };
  }, []);
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div className="inner-content">
          <div className="container px-0">
            <div className="row mx-0">
              <div className="container px-0">
                <div class="row mx-0">
                  <div class="shadowclass top_filters orderpayy mb-3">
                    <h4 class="event-alert py-0 my-2">Filters </h4>
                    <div className="row mx-0">
                      <div class="col-lg-4 col-md-6 pl0 px-0 px-sm-3">
                        <div class="calander d-flex align-items-center">
                          <div class="datePicker pading_right">
                            {/* // <div class="input-append bootstrap-timepicker date-input datepicker2 date">
                            //   <input
                            //     name="from_date"
                            //     class=" "
                            //     required="required"
                            //     type="text"
                            //     id=""
                            //     value="2022-05-01"
                            //   />
                            //   <span class="add-on">
                            //     <i class="fa fa-calendar"></i>
                            //   </span>
                            // </div> */}
                            <DatePicker
                              selected={startDate}
                              dateFormat="dd/MM/yyyy"
                              onChange={(date) => {
                                setStartDate(date);
                                setData({
                                  ...data,
                                  from_date: moment(date).format("yyyy-MM-DD"),
                                });
                              }}
                            />
                          </div>
                          <div class="datePicker pading_lect">
                            {/* <div class="input-append bootstrap-timepicker date-input datepicker2 date">
                              <input
                                name="to_date"
                                class=" "
                                required="required"
                                type="text"
                                id=""
                                value="2022-05-13"
                              />
                              <span class="add-on">
                                <i class="fa fa-calendar"></i>
                              </span>
                            </div> */}
                            <DatePicker
                              selected={endDate}
                              dateFormat="dd/MM/yyyy"
                              onChange={(date) => {
                                setEndDate(date);
                                setData({
                                  ...data,
                                  to_date: moment(date).format("yyyy-MM-DD"),
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-2 col-md-6 timing-duration pt-4 pt-sm-0 mt-md-3 mt-0 mt-lg-0 px-sm-2">
                        <MultiRangeSlider
                          min={0}
                          max={1440}
                          timeRange
                          format="12"
                          onChange={({ min, max }) => {
                            console.log(`min = ${min}, max = ${max}`);
                            setData({
                              ...data,
                              start_time: min,
                              end_time: max,
                            });
                          }}
                        />
                      </div>
                      <div class="selecters col-lg-5 col-md-10 pl-md-0 row mx-0 justify-content-between pt-0 pt-lg-0">
                        <div class="select-div col px-1 pl-md-0">
                          <div class="input select">
                            <select
                              name="waste_group"
                              class="csutom_select"
                              id="WasteWasteGroup"
                              onChange={(e) =>
                                setData({
                                  ...data,
                                  status: e.target.value,
                                })
                              }
                            >
                              {discountsData?.status?.map((el) => (
                                <option value={el?.value}>{el?.label}</option>
                              ))}
                            </select>
                          </div>{" "}
                        </div>
                        <div class="select-div col px-1">
                          <div class="input select">
                            <select
                              name="waste_type"
                              class="csutom_select"
                              id="WasteWasteType"
                              onChange={(e) =>
                                setData({
                                  ...data,
                                  type: e.target.value,
                                })
                              }
                            >
                              {discountsData?.type?.map((el) => (
                                <option value={el?.value}>{el?.label}</option>
                              ))}
                            </select>
                          </div>{" "}
                        </div>
                        <div class="select-div col px-1">
                          <div class="input select">
                            <select
                              name="supplier"
                              class="csutom_select"
                              id="WasteSupplier"
                              onChange={(e) =>
                                setData({
                                  ...data,
                                  payment_method: e.target.value,
                                })
                              }
                            >
                              {discountsData?.payment_method?.map((el) => (
                                <option value={el?.value}>{el?.label}</option>
                              ))}
                            </select>
                          </div>{" "}
                        </div>
                      </div>
                      <div class="col-lg-1 col px-0 pt-3 pt-lg-0 align-right">
                        <button
                          onClick={() => {
                            dispatch(actions?.getDiscountsData(data));
                          }}
                          class="btn btn_btnblue"
                          type="submit"
                        >
                          Search
                        </button>
                      </div>
                    </div>
                  </div>{" "}
                </div>
              </div>
            </div>
            <div className="accordion" id="accordionPanelsStayOpenExample">
              <div className="accordion-item">
                <h2
                  className="accordion-header"
                  id="panelsStayOpen-headingNine3"
                >
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseNine3"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseNine3"
                  >
                    <div className="col d-flex align-items-center justify-content-between">
                      <h4 className="event-alert p-0 mb-0">Discounts</h4>
                    </div>
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseNine3"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingNine3"
                >
                  <div className="">
                    <div className="row mx-0">
                      <div className="container px-0">
                        <div className="shadowclass mt-0">
                          <div class="d-flex justify-content-between align-items-center flex-wrap">
                            <div className="col-md-4 col-12">
                              <div className="search-box mt-0">
                                <form type="GET">
                                  <input
                                    type="text"
                                    placeholder="Search"
                                    name="keyword1"
                                  />
                                  <input type="submit" />
                                </form>
                              </div>
                            </div>
                            <div class="col-sm-auto text-small align-right col-12 mt-2 mt-sm-0">
                              <i>Last Upload July 13, 2022 02:23 PM</i>
                            </div>
                          </div>
                          <div className="table-responsive general-setting saved_order_ms">
                            <div className="orderList">
                              <table className="checklist-table remove-space ingredTable">
                                <thead>
                                  <tr>
                                    <th>Discount Date/Time</th>
                                    <th>Discount ID</th>
                                    <th>Order ID</th>
                                    <th>Order Item ID</th>
                                    <th>Menu Item</th>
                                    <th>Discount %</th>
                                    <th>Discount Amount</th>
                                    <th>Server</th>
                                    <th>Type</th>
                                    <th>Service Period</th>
                                    <th className="action-td">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {discountsData?.orders?.data?.map((el, idx) =>
                                    el?.pos_order_menuitem
                                      ?.filter(
                                        (menuEl) => menuEl?.discount != 0
                                      )
                                      ?.map((filteredMenuEl) => (
                                        <tr>
                                          <td>
                                            {el?.order_create_date?.slice(
                                              0,
                                              10
                                            ) +
                                              " " +
                                              el?.order_create_date?.slice(
                                                11,
                                                19
                                              )}
                                          </td>
                                          <td>
                                            {"D_" +
                                              el?.order_id +
                                              "_" +
                                              idx +
                                              1}
                                          </td>
                                          <td>{el?.order_id}</td>
                                          <td>
                                            {"OI_" +
                                              el?.order_id +
                                              "_" +
                                              idx +
                                              1}
                                          </td>
                                          <td>
                                            {
                                              filteredMenuEl?.menu_item
                                                ?.menu_item_name
                                            }
                                          </td>
                                          <td>
                                            {
                                              filteredMenuEl?.discount_percentage
                                            }
                                          </td>
                                          <td>{filteredMenuEl?.discount}</td>
                                          <td>{el?.user?.full_name}</td>
                                          <td>{el?.sales_type?.type_name}</td>
                                          <td>
                                            {el?.service_period_date
                                              ? el?.service_period
                                                  ?.period_name +
                                                " - " +
                                                moment(
                                                  el?.service_period_date
                                                ).format("Do MMMM,YYYY")
                                              : el?.order_service_period}
                                          </td>

                                          <td className="action-td">
                                            <a
                                              onClick={() => {
                                                dispatch(
                                                  actions?.getBillData({
                                                    order_id: el?.id,
                                                    page: "discount",
                                                  })
                                                );
                                                history.push(
                                                  "/finance/sales/bill",
                                                  "discount"
                                                );
                                              }}
                                              class="circle_icon"
                                            >
                                              <i class="iconSprites eye-icon"></i>
                                            </a>
                                          </td>
                                        </tr>
                                      ))
                                  )}
                                </tbody>
                              </table>
                            </div>

                            <div className="row mx-0 justify-content-between">
                              <div class="show_count col">
                                Showing {discountsData?.orders?.current_page}{" "}
                                out of {discountsData?.orders?.last_page}{" "}
                              </div>
                              <div class="pagination mt-2 col">
                                <span class="number-first">
                                  <a
                                    onClick={() => {
                                      handleClick(1);
                                    }}
                                  >
                                    First
                                  </a>
                                </span>{" "}
                                <span
                                  onClick={() => {
                                    discountsData?.orders?.current_page - 1 >
                                      0 &&
                                      handleClick(
                                        discountsData?.orders?.current_page - 1
                                      );
                                  }}
                                  class="prev"
                                >
                                  Previous
                                </span>{" "}
                                <span class="current">
                                  {discountsData?.orders?.current_page}
                                </span>{" "}
                                <span
                                  onClick={() => {
                                    console.log(
                                      discountsData?.orders?.current_page,
                                      discountsData?.orders?.last_page
                                    );
                                    +discountsData?.orders?.current_page + 1 <=
                                      +discountsData?.orders?.last_page &&
                                      handleClick(
                                        discountsData?.orders?.current_page + 1
                                      );
                                  }}
                                  class="next"
                                >
                                  Next
                                </span>{" "}
                                <span class="number-end">
                                  <a
                                    onClick={() => {
                                      handleClick(
                                        discountsData?.orders?.last_page
                                      );
                                    }}
                                  >
                                    Last
                                  </a>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default Discounts;
